<template>
  <v-card flat>
    <v-card-title class="px-0" v-text="$attrs.label" />
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="computedValue.minimum"
          class="rounded-lg pe-md-1"
          clearable
          dense
          label="از"
          outlined
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="computedValue.maximum"
          class="rounded-lg ps-md-1"
          clearable
          dense
          label="تا"
          outlined
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "InputRangePicker",

  props: {
    value: {
      type: Object,
      default: () => ({ minimum: null, maximum: null }),
    },
  },

  computed: {
    computedValue: {
      get() {
        return this.value || { minimum: null, maximum: null };
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped></style>
